/* eslint-disable indent */
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import exportToExcel from '../../api/export.js';
import BorderContainerDark from '../border-container/border-container-dark.jsx';
import styles from './modal.module.scss';

function Legend({ className }) {
  return (
    <div className={classNames(styles.legendBox, className)}>
      <div className={styles.legendItem}>
        <div className={classNames(styles.legendIcon, styles.dataGreen)} />
        <div className={styles.legendText}>=Outstanding</div>
      </div>
      <div className={styles.legendItem}>
        <div className={classNames(styles.legendIcon, styles.dataYellow)} />
        <div className={styles.legendText}>=Ready</div>
      </div>
      <div className={styles.legendItem}>
        <div className={classNames(styles.legendIcon, styles.dataRed)} />
        <div className={styles.legendText}>=Risky/High Risk</div>
      </div>
    </div>
  );
}

const NO_IMAGE =
  'data:image/png;base64,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';

const ModalGreen = ({ open, data = {}, avgs = [], modalType, closeModal }) => {
  const isPercent = useMemo(() => {
    return data?.isPercent ?? true;
  }, [data]);
  const max = useMemo(() => {
    return data?.max ?? 100.0;
  }, [data]);

  return Object.keys(data).length === 0 ? null : (
    <div className={classNames(styles.modalGreen, { [styles.open]: open })}>
      <div className={styles.anmateContent}>
        <div className={styles.modalContent}>
          <BorderContainerDark id="modal" breath={true}>
            <div className={styles.modalContentInner}>
              <div className={styles.modalHeader}>
                <div className={styles.textWrap}>{data?.title}</div>
                <div className={styles.closeButton} onClick={closeModal}></div>
              </div>
              <div className={styles.modalBody}>
                <div className={styles.modalImgWrap}>
                  <img
                    className={styles.modalImg}
                    src={data?.cover || NO_IMAGE}
                  />
                </div>
                <div
                  className={classNames(styles.modalTable, {
                    [styles.lower]: modalType === 0,
                  })}
                >
                  <div className={styles.tableContainer}>
                    <div className={styles.header}>
                      <div
                        className={classNames(
                          styles.firstCell,
                          styles.firstCell2
                        )}
                      >
                        <span className={styles.title}>{data?.table.title}</span>
                      </div>
                      <div
                        className={classNames(styles.cell, styles.barContent)}
                      >
                        {data?.table.barContent}
                      </div>
                    </div>
                    <div className={styles.body}>
                      {data?.table.body.map((item, index) => (
                        <div className={styles.row} key={index}>
                          <div className={styles.firstCell}>
                            <div className={styles.firstCell1}>
                              <Tooltip
                                placement="top"
                                color={'#015719'}
                                title={item.titleTip}
                              >
                                <QuestionCircleOutlined
                                  style={{ color: '#00a32e' }}
                                />
                              </Tooltip>
                              <div
                                className={classNames(
                                  styles.title,
                                  styles.title2
                                )}
                              >
                                {item.title}
                              </div>
                            </div>
                            <span className={styles.avg}>
                              Avg: {(avgs[index] ?? 0).toFixed(2)}
                              {isPercent ? '%' : ''}
                            </span>
                          </div>
                          <div
                            className={classNames(
                              styles.cell,
                              styles.barContent
                            )}
                          >
                            <div className={styles.barWrap}>
                              <div className={styles.num}>
                                {!item.score
                                  ? '-'
                                  : `${item.score.toFixed(2)}${
                                      isPercent ? '%' : ''
                                    }`}
                              </div>
                              <div className={styles.barContainer}>
                                <div
                                  className={classNames(styles.bar, {
                                    [styles.yellow]: item.flag === 'normal',
                                    [styles.red]: item.flag === 'bad',
                                  })}
                                  style={{
                                    width: `${(item.score / max) * 100}%`,
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <Legend className={styles.modalLegend} />
                </div>
              </div>
              <div className={styles.modalFooter}>
                <div
                  className={styles.btnExport}
                  onClick={() => {
                    exportToExcel(data?.title, data?.table.body);
                  }}
                ></div>
              </div>
            </div>
          </BorderContainerDark>
        </div>
      </div>
      <div className={styles.modalMask}></div>
    </div>
  );
};

ModalGreen.propTypes = {
  open: PropTypes.bool.isRequired,
  modalType: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
    market: PropTypes.string,
    table: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
      barContent: PropTypes.string,
      body: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          score: PropTypes.number,
          barContent: PropTypes.number,
          flag: PropTypes.string,
        })
      ),
    }),
  }),
};

export default ModalGreen;
